/**
 * @file Application Paths
 * @desc This file contains the paths used by the application's router.
 * @module paths
 * @doc router
 */

/**
 * @constant {Object} SETTINGS
 * @desc Contains the base paths for the /settings section of the application.
 */
export const SETTINGS = {
  // Base paths for the settings section.
  ACCOUNT: 'account',
  BASE: 'settings',

  // Common paths for the settings section.
  DASHBOARD: 'dashboard',
  LOGS: 'logs',
  PROFILE: 'profile',

  // Admin-specific paths.
  DOMAINS: 'domains',
  ENTERPRISE: 'enterprise',
  PROJECTS: 'projects',
  PROVIDERS: 'providers',
  SECURITY: 'security',
  USERS: 'users',
}

export const ADMIN = {
  // Inherit the base paths from SETTINGS.
  ...SETTINGS,

  // Overwrite the base path.
  BASE: 'admin',

  // Add paths specific to ADMIN.
  PROJECT_SYNC: 'project-sync',
}

const paths = {
  ACCOUNT: SETTINGS, // Alias to settings.

  ADMANAGER: {
    BASE: 'admanager',
    CREATIVES: 'creatives',
    LINEITEMS: 'lineitems',
    NETWORKS: 'networks',
    ORDERS: 'orders',
  },

  ADMIN,

  DASHBOARD: {
    BASE: 'dashboard',
    HOME: '',
    REGISTER_ACCOUNT: 'register-account',
    RESET_PASSWORD: 'reset-password',
    SIGN_IN: 'sign-in',
    SIGN_UP: 'sign-up',
    SIGN_OUT: 'sign-out',
  },

  DOCS: {
    BASE: 'docs',
    DASHBOARD: 'dashboard',
    BACKLOG: 'backlog',
    DATA_REFRESH: 'data-refresh',
    DEPRECATION: 'deprecation',
    DOCS: 'docs',
    FEATURES: 'features',
    FILTERS: 'filters',
    LEGAL: 'legal',
    RELEASES: 'releases',
    RELEASE_NOTES: 'release-notes',
    ROADMAPS: 'roadmaps',
    PRIVACY_POLICY: 'privacy-policy',
    WHITELIST: 'whitelist',
  },

  REPORTS: {
    // Base paths.
    BASE: 'reports',
    DELIVERY: 'delivery',
    PROGRAMMATIC: 'programmatic',

    // Report paths.
    DISCREPANCY: 'discrepancy',
    PACING: 'pacing',
    ADX_HEALTH: 'adx-health',
    NETWORK_HEALTH: 'network-health',
    YIELD_PARTNER: 'adx-and-ob',
  },

  INTERNAL: {
    BASE: 'internal',
    ORGANIZATION: 'organization',
    PERSON: 'person',
    PROJECT: 'project',
    TIME: 'time',
  },

  CUSTOM_REPORTS: {
    BASE: 'custom-reports',
    CAMPAIGN_TRACKING: 'campaign-tracking',
    CAMPAIGN_TRACKING_1: 'campaign-tracking-1',
    CAMPAIGN_TRACKING_2: 'campaign-tracking-2',
    MONTHLY_PROGRESS: 'monthly-progress',
    PROGRESS_REPORT: 'progress-report',
    REVENUE: 'revenue',
    REVENUE_AT_RISK: 'revenue-at-risk',
    SCHNEPS_MID_MONTH: 'schneps-mid-month',
  },

  SETTINGS, // Aliases: admin.
}

export default paths
